module.exports = __webpack_public_path__ + "static/media/twitter.39c0e45d.svg";